import { render } from "./UserDetailsModal.vue?vue&type=template&id=8c5a1796&scoped=true"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js"

import "./UserDetailsModal.vue?vue&type=style&index=0&id=8c5a1796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5a1796"]])

export default __exports__